import React, { ReactNode } from 'react'
import { Dialog, DialogProps } from '@mui/material'
import { SxProps, Theme } from '@mui/material/styles'

export interface BaseModalProps {
  children: ReactNode
  fullScreen?: boolean
  onClose?: () => void
  open?: boolean
  paperSx?: SxProps<Theme>
  sx?: SxProps<Theme>
  transitionComponent?: DialogProps['TransitionComponent']
  transitionProps?: DialogProps['TransitionProps']
}

const BaseModal = ({
  children,
  fullScreen = false,
  onClose,
  open = true,
  paperSx,
  sx,
  transitionComponent,
  transitionProps
}: BaseModalProps) => (
  <Dialog
    open={open}
    onClose={onClose}
    fullScreen={fullScreen}
    maxWidth={false}
    TransitionComponent={transitionComponent}
    TransitionProps={transitionProps}
    PaperProps={{
      sx: paperSx
    }}
    sx={sx}
  >
    {children}
  </Dialog>
)

export default BaseModal
